<template>
  <nav-bar title="通知公告">
    <template #right>
      <van-button type="default" size="mini" :to="`/reportDetail/${uuid}`"
        >举报</van-button
      >
    </template>
  </nav-bar>
  <Content :bottom="0" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="list">
      <li
        class="list-item"
        v-for="item in list"
        :key="item.id"
        @click="$router.push(`/announcementDetail/${item.id}`)"
      >
        <p>{{ item.newsTitle }}</p>
        <div>{{ item.createtime }}</div>
      </li>
    </ul>
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="getList"
    />
  </Content>
</template>

<script>
import { getUserNewsList } from '@/api/viewGasCylinder'
import { useLoadingMore } from '@/hooks/useLoadingMore'
export default {
  name: 'AnnouncementList', // 通知公告
  props: ['uuid'],
  setup() {
    const data = useLoadingMore(getUserNewsList)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.page = 1
      pageParams.pageNum = 15
      finished.value = false
      loadingFail.value = false

      getList()
    }
    init()
    return {
      ...data,
      list
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  font-size: 14px;
  padding: 0 16px;
  line-height: 22px;
  .list-item {
    padding: 10px;
    background-color: #fff;
    margin-top: 10px;
    p {
      margin: 0;
      color: #333;
    }
    div {
      font-size: 12px;
      color: #666;
    }
  }
}
</style>
